import * as React from 'react';
import  request  from '@/server/request';
import config from '@/server/config';
import './scss/form.scss';
// import UploadImg from '@/pages/components/uploadImg';
import DatePicker from '@/pages/components/datePicker';
import store from '@/redux/index';
import { types } from '@/redux/ui/address';
import alert from '@/pages/components/common/alert';
import { PickerBox } from '@/pages/components/picker';
import * as moment from 'moment';

interface initProps{
	history: any,
}

class ComponentAuthStep1 extends React.Component <initProps , any> {
	constructor(props: any) {
		super(props);
		this.state = {
			// 是否是企业认证变更
			actiontype: '',
			visiblity: false,
			isSubmiting: false,
			form: {
				type: '',
				company: '',  // 企业名称
				licenceCreditCode: '', // 社会信用码
				companyCategory: '', // 企业分类
				companyType: '', // 公司类型
				companyCategoryValue: '', // 企业分类中文
				authType: 0, 
				establishTime: '', // 成立时间
				registeredCapital: '', // 注册资本
				currency: '', // 币别
				companyLegalPerson: '', // 法人
				companyLegalPersonIdCard: '', //法人身份证
				licenceExptimeFlag: '0', // 营业执照类型 1日期 0长期
				isManageHazardous: '0', // 是否经营危化品 0否 1是
				hazardousLicenceExptime: '', // 危化品许可证到期时间 是否经营危化品为1时必填
				manageHazardousWay: '', // 危化品经营方式 是否经营危化品为1时必填 50字以内
				licenceCityCode: '', // 住址所在城市code
				licenceCountyCode: '', // 住址所在区县code
				licenceDetailAddress: '', // 住址所在详细地址
				licenceProvinceCode: '', // 住址所在省份code
				licenceExptime: '', // 营业执照到期时间 营业执照类型为1时必填
			},
			addressZN: '',
			addressInfo: {
                city: {
                    code: '',
                    name: '',
                },
                district: {
                    code: '',
                    name: '',
                },
                province: {
                    code: '',
                    name: '',
                }
			},
			// 企业分类
			componentsTypeData: {
				displayValue (item: any) {
		        	return item.name;
		    	},
		    	list: [],
			},
		}
	}

	componentDidMount() {
		this.getCompanyType();

		let tempActiontype = '';
		const tempState = this.props.history.location.state;
		if(tempState && tempState.actiontype) {
			tempActiontype = tempState.actiontype;
		}
		if (tempActiontype) {
			this.setState({ actiontype: tempActiontype }, () => {
				this.initData();
			});
		} else {
			this.initData();
		}
	}

	render() {
		return (
			<div className="gray-bg">
				<div className="process">
					<div className="process-item active"> 
						<div className="num-warrrper">
							<span className="num">1</span>
						</div>
						<p className="title">工商信息</p>
					</div>
					<div className="process-item"> 
						<div className="num-warrrper">
							<span className="num">2</span>
						</div>
						<p className="title">开票信息</p>
					</div>
					<div className="process-item"> 
						<div className="num-warrrper">
							<span className="num">3</span>
						</div>
						<p className="title">上传附件</p>
					</div>
				</div>
				<div className="default-form margin-down-default">
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>公司名称</label>
						<input 
							type="text" 
							placeholder="请输入公司名称" 
							className="text-right"  
							readOnly ={this.state.form.type !== 2 && this.state.form.type !== 4} 
							value={this.state.form.company}
							onChange={ (e:any) => this.setForm('company', e.target.value) }  />
					</div>
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>社会信用代码</label>
						<input 
							type="text" 
							placeholder="请输入社会信用代码" 
							className="text-right" 
							readOnly ={true} 
							value={this.state.form.licenceCreditCode}/>
					</div>
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>企业类型</label>
						<button className="input-select text-right" 
						data-value={this.state.form.companyCategoryValue ? this.state.form.companyCategoryValue : '' }
						onClick={() => this.showCompanyType() }
						disabled={this.state.form.type !== 2 && this.state.form.type !== 4} 
						>
							{this.state.form.companyCategoryValue ? this.state.form.companyCategoryValue : '请输入企业分类' }
						</button>
					</div>
				</div>

				<div className="default-form margin-down-default">
					<div className="form-input-warrper">
						<label className="label">成立日期</label>
						<button 
							className="input-select text-right" 
							data-value={this.state.form.establishTime ? this.state.form.establishTime : ''} 
							onClick={() => this.selectDate('establishTime') }>
							{this.state.form.establishTime ? this.state.form.establishTime : '请选择'}
						</button>
					</div>
					<div className="form-input-warrper">
						<label className="label">币种</label>
						<button className="input-select text-right" data-value={this.state.form.currency ? this.state.form.currency : '' } onClick= {() => this.showComponentsType()}>
							{this.state.form.currency ? this.state.form.currency : '请输入币种' }
						</button>
					</div>
					<div className="form-input-warrper">
						<label className="label">注册资本</label>
						<input 
							type="number" 
							placeholder="请输入注册资本" 
							className="text-right" 
							value={this.state.form.registeredCapital}
							onChange={ (e:any) => this.setForm('registeredCapital', e.target.value) }/>
						<span className="right-unit">万</span>
					</div>
					<div className="form-input-warrper">
						<label className="label">公司法人</label>
						<input 
							type="text" 
							placeholder="请输入公司法人" 
							className="text-right" 
							value={this.state.form.companyLegalPerson}
							onChange={ (e:any) => this.setForm('companyLegalPerson', e.target.value) }/>
					</div>
					<div className="form-input-warrper">
						<label className="label">法人身份证</label>
						<input 
							type="text" 
							placeholder="请输入法人身份证" 
							className="text-right" 
							value={this.state.form.companyLegalPersonIdCard ? this.state.form.companyLegalPersonIdCard : ''}
							onChange={ (e:any) => this.setForm('companyLegalPersonIdCard', e.target.value) }/>
					</div>
					<div className="form-input-warrper">
						<label className="label">公司类型</label>
						<input 
							type="text" 
							placeholder="请输入公司类型" 
							className="text-right" 
							value={this.state.form.companyType}
							onChange={ (e:any) => this.setForm('companyType', e.target.value) }/>
					</div>
					<div className="form-input-warrper">
						<label className="label">是否长期营业</label>
						<div className="form-radio-group">
							<div className ="radio-item">
								<div className="radio-box">
									<input 
										type="radio" 
										name="radio2"  
										className="radio"
										checked={this.state.form.licenceExptimeFlag.toString() === '0'}  
										onChange={(e:any) => { 
											if(e.target.checked) { 
												this.setForm('licenceExptimeFlag', e.target.value ? 0 : '')
											}  
										}} />
									<span className="radio-icon"></span>
								</div>
								<label className="radio-text">是</label>
							</div>
							<div className ="radio-item">
								<div className="radio-box">
									<input 
										type="radio" 
										name="radio2"  
										className="radio"
										checked={this.state.form.licenceExptimeFlag.toString() === '1'}
										onChange={(e:any) => { 
											if(e.target.checked) { 
												this.setForm('licenceExptimeFlag', e.target.value ? 1 : '')
											}  
										}} />
									<span className="radio-icon"></span>
								</div>
								<span className="radio-text">否</span>
							</div>
						</div>
					</div>
					{
						this.state.form.licenceExptimeFlag.toString() === '1' ?
							<div className="form-input-warrper">
								<label className="label">营业执照到期时间</label>
								<button 
									className="input-select text-right" 
									data-value={this.state.form.licenceExptime ? this.state.form.licenceExptime : ''}
									onClick={() => this.selectDate('licenceExptime') }>
										{this.state.form.licenceExptime ? this.state.form.licenceExptime : '请选择'}
								</button>
							</div> : ''
					}
					<div className="form-input-warrper">
						<label className="label">住所</label>
						<button className="input-select text-right" data-value={this.state.addressZN ? this.state.addressZN : ''} onClick={() => this.openAddressPanel()}>
							{
								this.state.addressZN ? this.state.addressZN : '选择区域'
							}
						</button>
					</div>
					<div className="form-input-warrper">
						<input 
							type="text" 
							placeholder="请输入详细地址" 
							className="text-right" 
							value={this.state.form.licenceDetailAddress}
							onChange={ (e:any) => this.setForm('licenceDetailAddress', e.target.value) }/>
					</div>
				</div>

				<div className="default-form margin-down-default">
					<div className="form-input-warrper">
						<label className="label"><span className="red">*</span>是否经营危险化学品</label>
						<div className="form-radio-group">
							<div className ="radio-item">
								<div className="radio-box">
									<input 
										type="radio" 
										name="radio"  
										className="radio"
										checked={this.state.form.isManageHazardous.toString() === '1'}
										onChange={(e:any) => { 
											if(e.target.checked) { 
												this.setForm('isManageHazardous', e.target.value ? 1 : '')
											}  
										}} />
									<span className="radio-icon"></span>
								</div>
								<label className="radio-text">是</label>
							</div>
							<div className ="radio-item">
								<div className="radio-box">
									<input 
										type="radio" 
										name="radio"  
										className="radio"
										checked={this.state.form.isManageHazardous.toString() === '0'}
										onChange={(e:any) => { 
											if(e.target.checked) { 
												this.setForm('isManageHazardous', e.target.value ? 0 : '')
											}  
										}} />
									<span className="radio-icon"></span>
								</div>
								<span className="radio-text">否</span>
							</div>
						</div>
					</div>
					{
						this.state.form.isManageHazardous.toString() === '1' ?
							<div className="form-input-warrper">
								<label className="label"><span className="red">*</span>危险品许可经营方式</label>
								<input 
									type="text" 
									placeholder="请输入经营方式" 
									className="text-right" 
									value={this.state.form.manageHazardousWay}
									onChange={ (e:any) => this.setForm('manageHazardousWay', e.target.value) }/>
							</div> : ''
					}

					{
						this.state.form.isManageHazardous.toString() === '1' ?
							<div className="form-input-warrper">
								<label className="label"><span className="red">*</span>许可证到期时间</label>
								<button 
									className="input-select text-right" 
									data-value={this.state.form.hazardousLicenceExptime ? this.state.form.hazardousLicenceExptime : ''} 
									onClick={() => this.selectDate('hazardousLicenceExptime') } >
										{this.state.form.hazardousLicenceExptime ? this.state.form.hazardousLicenceExptime : '请选择到期时间'}
								</button>
							</div> : ''
					}
					
				</div>

				<div className="form-btn-warrrper clearfix">
					<button className="form-btn" onClick={() =>  this.submitForm() }>下一步</button>
					{
						this.state.form.type !== 2 && this.state.form.type !== 4 ?
						<button className="form-btn white" onClick={() => this.props.history.replace('/auth/component?init=1')  }>返回上一步</button>
						: null
					}
				</div>
			</div>
		)
	}

	// 表单赋值
	private setForm(name?: string, val?: any) {

		if(!name) {
			return ;
		}
		this.state.form[name] = val;
		this.setState({
			form: { 
				...this.state.form,
			} 
		})
	}

	// 检测表单
	private checkForm() {
		const companyNameReg = /[。\/？》《\>\<\~\!\@\#\%\$\%\^\&\*]/
		const companyNameHasNumReg = /\d/
		const compnayNameHasEnglish = /[a-zA-Z]/
		const companyNameChinese = /[\u4e00-\u9fa5]/
		const companyNameHasBlank = /[\r\s]/
		if(!this.state.form.company || this.state.form.company.trim() === '') {
			return alert.open({
				promptText: '请输入公司名称'
			});
		}
		if (companyNameReg.test(this.state.form.company)) {
			return alert.open({
				promptText: '企业名称存在特殊字符，请重新输入！'
			});
		}
		if (companyNameChinese.test(this.state.form.company)) {
			if (!compnayNameHasEnglish.test(this.state.form.company) && companyNameHasBlank.test(this.state.form.company)) {
				return alert.open({
					promptText: '企业名称存在空格，请重新输入'
				});
			}
		}
		if (companyNameHasNumReg.test(this.state.form.company)) {
			return alert.open({
				promptText: '企业名称不能存在数字，请重新输入！'
			});
		}
		if (this.state.form.licenceCreditCode === '') {
			return alert.open({
	    		promptText: '请填写社会信用代码',
	    	});
		} else if(!/^[A-Z\d\-]{18,20}$/.test(this.state.form.licenceCreditCode)) {
			return alert.open({
	    		promptText: '社会信用代码18位到20位，只能包括数字、大写英文字母或-',
	    	});
		}
		/**
		if(this.state.form.establishTime.toString().replace(/\s/gi, '') === '') {
			alert.open({
	    		promptText: '请选择成立时间',
	    	})
			return ;
		}
		if(this.state.form.currency.replace(/\s/gi, '') === '') {
			alert.open({
	    		promptText: '请选择币种',
	    	})
			return ;
		}
		if(this.state.form.registeredCapital.toString().replace(/\s/gi, '') === '') {
			alert.open({
	    		promptText: '请输入注册资本',
	    	})
			return ;
		}
		if(this.state.form.companyLegalPerson.replace(/\s/gi, '') === '') {
			alert.open({
	    		promptText: '请输入法人',
	    	})
			return ;
		} else 
		**/
		if(this.state.form.companyLegalPerson.length > 100) {
			return alert.open({
				promptText: '公司法人不能超过100个字'
			});
		}
		/**
		if(this.state.form.licenceExptimeFlag.toString().replace(/\s/gi, '') === '') {
			alert.open({
	    		promptText: '请选择是否长期营业',
	    	})
			return ;
		}
		**/
		if(this.state.form.isManageHazardous.toString().replace(/\s/gi, '') === '') {
			alert.open({
	    		promptText: '请选择是否经营危化品',
	    	})
			return ;
		}
		/**
		if(this.state.form.companyLegalPersonIdCard.toString().replace(/\s/gi, '') !== '' && this.state.form.companyLegalPersonIdCard.toString().replace(/\s/gi, '').length > 18 ) {
			alert.open({
	    		promptText: '法人身份证有误',
	    	})
			return ;
		}
		**/
		// 如果选择经营化学品
		if(this.state.form.isManageHazardous.toString() === '1') {
			if(this.state.form.hazardousLicenceExptime.toString().replace(/\s/gi, '') === '') {
				alert.open({
		    		promptText: '请选择危化品许可证到期时间',
		    	})
				return ;
			}
			if(this.state.form.manageHazardousWay.toString().replace(/\s/gi, '') === '') {
				alert.open({
		    		promptText: '请输入危化品经营方式',
		    	})
				return ;
			}
		}
		/**
		if(this.state.form.licenceCityCode.replace(/\s/gi, '') === '' || this.state.form.licenceProvinceCode.replace(/\s/gi, '') === '' || this.state.form.licenceCountyCode.replace(/\s/gi, '') === '') {
			alert.open({
	    		promptText: '住址有误',
	    	})
			return ;
		}
		if(this.state.form.licenceDetailAddress.replace(/\s/gi, '') === '') {
			alert.open({
	    		promptText: '请输入详细地址',
	    	})
			return ;
		}
		if(this.state.form.licenceExptimeFlag.toString() === '1') {
			if(this.state.form.licenceExptime.toString().replace(/\s/gi, '') === '') {
				alert.open({
		    		promptText: '请选择营业执照到期时间',
		    	})
				return ;
			}
		}
		**/
		return true
	}

	// 提交表单
	private async submitForm() {
		if(!this.checkForm()) {
			return ;
		}

		// 防止重复提交
		if(this.state.isSubmiting) {
			return ;
		}

		this.setState({
			isSubmiting: true
		})

		const r = await request({
	      method: "post",
	      url: `${config.CE}member/auth/company/submit/step/1`,
	      data: {
	      	...this.state.form
	      }
	    });

		this.setState({
			isSubmiting: false,
		})

	    if(r.code !== 1) {
	    	alert.open({
	    		promptText: r.msg,
	    	})
	    }else {
	    	this.setState({
	    		form: {
					company: '',  // 企业名称
					licenceCreditCode: '', // 社会信用码
					companyCategory: '', // 企业分类
					companyType: '', // 公司类型
					companyCategoryValue: '', // 公司类型中文
					authType: this.state.actiontype || 0, 
					establishTime: '', // 成立时间
					registeredCapital: '', // 注册资本
					currency: '', // 币别
					companyLegalPerson: '', // 法人
					companyLegalPersonIdCard: '', //法人身份证
					licenceExptimeFlag: '', // 营业执照类型 1日期 0长期
					isManageHazardous: '', // 是否经营危化品 0否 1是
					hazardousLicenceExptime: '', // 危化品许可证到期时间 是否经营危化品为1时必填
					manageHazardousWay: '', // 危化品经营方式 是否经营危化品为1时必填 50字以内
					licenceCityCode: '', // 住址所在城市code
					licenceCountyCode: '', // 住址所在区县code
					licenceDetailAddress: '', // 住址所在详细地址
					licenceProvinceCode: '', // 住址所在省份code
					licenceExptime: '', // 营业执照到期时间 营业执照类型为1时必填
				}
	    	}, () => {
	    		this.props.history.push('/auth/step2', {actiontype: this.state.actiontype})
	    	})
	    }
	}

	// 返回初始化数据
	private async initData() {
		const r = await request({
			method: "get",
			url: `${config.CE}member/company/info?type=${this.state.actiontype}`,
		});

		if (r.code !== 1) {
			alert.open({
				promptText: r.msg,
			})
		} else {
			const {memberInfo, companyInfo} = r.obj;
			const checkNull = (data: any) => {
				return data ? data : '' 
			}

			let data: any;
			data = companyInfo !== null ? ((companyInfo.applyRecode && (companyInfo.applyRecode.type === 2 || companyInfo.applyRecode.type ===4)) ? companyInfo : memberInfo) :  memberInfo;

			this.setState({
				addressZN: companyInfo ? (companyInfo.licenceProvinceName+ companyInfo.licenceCityName + companyInfo.licenceCountyName) : '' , 
				form: {
					type: (companyInfo && companyInfo.applyRecode) ? companyInfo.applyRecode.type : '',
					company: data ? checkNull(data.company) : '',  // 企业名称
					licenceCreditCode: data ? checkNull(data.licenceCreditCode) : '', // 社会信用码
					companyCategory: data ? checkNull(data.companyCategory) : '', // 企业分类
					companyCategoryValue:  data ? checkNull(data.companyCategoryValue) : '', // 公司分类zh
					companyType: companyInfo ? checkNull(companyInfo.companyType) : '', // 公司类型
					authType: this.state.actiontype || 0, 
					establishTime: companyInfo ? (checkNull(companyInfo.establishTime) ? moment(companyInfo.establishTime).format('YYYY-MM-DD') : '') : '', // 成立时间
					registeredCapital: companyInfo ? checkNull(companyInfo.registeredCapital) : '', // 注册资本
					currency: companyInfo ? checkNull(companyInfo.currency) : '', // 币别
					companyLegalPerson: companyInfo ? checkNull(companyInfo.companyLegalPerson) : '', // 法人
					companyLegalPersonIdCard: companyInfo ? checkNull(companyInfo.companyLegalPersonIdCard) : '', //法人身份证
					licenceExptimeFlag: companyInfo ? (companyInfo.licenceExptimeFlag ? companyInfo.licenceExptimeFlag : '0') : '0', // 营业执照类型 1日期 0长期
					isManageHazardous: companyInfo ? (companyInfo.isManageHazardous ? companyInfo.isManageHazardous : '0') :  '0', // 是否经营危化品 0否 1是
					hazardousLicenceExptime:  companyInfo ? (checkNull(companyInfo.hazardousLicenceExptime) ? moment(companyInfo.hazardousLicenceExptime).format('YYYY-MM-DD') : '') : '', // 危化品许可证到期时间 是否经营危化品为1时必填
					manageHazardousWay: companyInfo ? checkNull(companyInfo.manageHazardousWay) : '', // 危化品经营方式 是否经营危化品为1时必填 50字以内
					licenceProvinceCode: companyInfo ? checkNull(companyInfo.licenceProvinceCode) : '',  // 住址所在省份code
					licenceCityCode: companyInfo ? checkNull(companyInfo.licenceCityCode) : '', // 住址所在城市code
					licenceCountyCode: companyInfo ? checkNull(companyInfo.licenceCountyCode) : '',  // 住址所在区县code
					licenceDetailAddress: companyInfo ? checkNull(companyInfo.licenceDetailAddress) : '',  // 住址所在详细地址	
					licenceExptime: companyInfo ?(checkNull(companyInfo.licenceExptime) ? moment(companyInfo.licenceExptime).format('YYYY-MM-DD') : '') : '', // 营业执照到期时间 营业执照类型为1时必填	
				}
			}, () => {
				// 显示企业名称
				// this.getTypeName();
			})
		}
	}

	// 打开地址面板
    private openAddressPanel() {
        const that = this;
        store.dispatch({
            type: types.ADDRESS_SHOW,
            showData: {
                init: that.state.addressInfo,
                onConfirm(r: any) {
                    that.setState({
						addressZN: r.province.name + r.city.name + r.district.name,
						form: {
							...that.state.form,
							licenceProvinceCode: r.province.code,
							licenceCityCode: r.city.code,
							licenceCountyCode: r.district.code
						}
					})

                }
            }
        });
    }

    /**
	  * @params name: state中需要更新字段的名字
    */
    private selectDate(name: any) {
    	const that = this;

    	DatePicker.open({
    	 	onCancelFn: (data: any) => {
    	 		let newData = {};
    	 		newData[name]= data.defaultDate;
    	 		
    	 		that.setState({
    	 			form: {
    	 				...this.state.form,
    	 				...newData,
    	 			}
    	 		})
    	 	}
    	})
    }

    // 显示下拉选择框
	private showComponentsType() {
		const that = this;
		const data = [{
			name: '人民币',
			value: '人民币',
		},{
			name: '美元',
			value: '美元',
		},{
			name: '港币',
			value: '港币',
		},{
			name: '澳门币',
			value: '澳门币',
		},{
			name: '日元',
			value: '日元',
		},{
			name: '韩币',
			value: '韩币',
		}, {
			name: '欧元',
			value: '欧元'
		}];

		// 显示弹框
		(PickerBox as any).open({
			data: [{
				displayValue (item: any) {
		        	return item.name;
		    	},
				list: data,
			}],
			// 成功回调
			onConfrim: (data: any) => {
				that.setState({
					form: {
						...this.state.form,
						currency: data.value
					}
				})
			}
		})
	}

	// 企业分类
	private async getCompanyType() {
		// 获取数据
		const r = await request({
	      method: "get",
	      url: `${config.CE}member/info/companyType`,
	    });
		if(r.code !== 1) {
			alert.open({
	    		promptText: r.msg,
	    	})
			return;
		}
		this.setState({
			componentsTypeData: {
				...this.state.componentsTypeData,
				list: r.obj
			}
		})
	}
	// 选择企业分类
	private showCompanyType() {
		const that = this;
		// 显示弹框
		(PickerBox as any).open({
			data: [{
				...that.state.componentsTypeData
			}],
			valueLable: 'id',

			// 成功回调
			onConfrim: (data: any) => {
				that.setState({
					form: {
						...this.state.form,
						companyCategoryValue: data.name,
						companyCategory: data.value,
					}
				})
			}
		})
	}
}

export default ComponentAuthStep1;